import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import 'datatables.net';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

const NodesTable = ({ data }) => {
  const tableRef = useRef(null);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tableApi, setTableApi] = useState(null);

  useEffect(() => {
    window.zoomToLocation = (lat, lng) => {
      const event = new CustomEvent('zoomToLocation', { detail: { lat, lng } });
      window.dispatchEvent(event);
    };

    const getStatusIcon = (status) => {
      if (status === "reporting") {
        return `
          <div style="display: flex; align-items: center;">
            <div style="width: 12px; height: 12px; border-radius: 50%; background-color: #10B981; margin-right: 8px;"></div>
            <span>Online</span>
          </div>
        `;
      }
      return status;
    };

    const table = $(tableRef.current).DataTable({
      data,
      columns: [
        { 
          title: 'Status', 
          data: 'status',
          render: function(data) {
            return getStatusIcon(data);
          }
        },
        {
          title: 'Node',
          data: 'node',
          render: function (data, type, row) {
            return `<a href="#" class="node-link" data-node="${data}">${data}</a>`;
          },
        },
        { title: 'City', data: 'city' },
        {
          title: 'GPS',
          data: 'gps',
          render: (data, type, row) =>
            `<a href="javascript:void(0);" onclick="zoomToLocation(${row.coords.lat}, ${row.coords.lng})">${data}</a>`,
        },
      ],
      dom: 'rt<"flex flex-col md:flex-row justify-between items-center mt-4"<"flex items-center"i>>',
      lengthMenu: [[5, 10, 20, 50], [5, 10, 20, 50]],
      pageLength: 10,
      pagingType: 'simple',
      responsive: true,
      scrollCollapse: true,
      autoWidth: false,
      fixedHeader: false,
      ordering: true,
      drawCallback: function(settings) {
        const api = this.api();
        const pageInfo = api.page.info();
        setCurrentPage(pageInfo.page + 1);
        setTotalPages(pageInfo.pages);
      }
    });

    setTableApi(table);

    $(tableRef.current).on('click', 'a.node-link', function (e) {
      e.preventDefault();
      const nodeId = $(this).data('node');
      window.open(`/node/${nodeId}`, '_blank');
    });

    return () => {
      table.destroy();
    };
  }, [data, navigate]);

  const handlePageChange = (pageNumber) => {
    if (tableApi) {
      tableApi.page(pageNumber - 1).draw('page');
    }
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value);
    if (tableApi) {
      tableApi.page.len(newRowsPerPage).draw();
      setRowsPerPage(newRowsPerPage);
    }
  };

  return (
    <div className="w-full overflow-x-auto">
      <table ref={tableRef} className="w-full table-auto border-collapse border border-gray-300"></table>
      <div className="flex justify-between items-center mt-4">
        <div className="flex items-center space-x-2">
          <span className="text-gray-700">Page {currentPage} of {totalPages}</span>
          <div className="flex gap-1">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              className="p-2 border rounded disabled:opacity-50 bg-white text-green-700 hover:bg-green-50 disabled:hover:bg-white"
            >
              <ChevronsLeft size={20} />
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="p-2 border rounded disabled:opacity-50 bg-white text-green-700 hover:bg-green-50 disabled:hover:bg-white"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="p-2 border rounded disabled:opacity-50 bg-white text-green-700 hover:bg-green-50 disabled:hover:bg-white"
            >
              <ChevronRight size={20} />
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="p-2 border rounded disabled:opacity-50 bg-white text-green-700 hover:bg-green-50 disabled:hover:bg-white"
            >
              <ChevronsRight size={20} />
            </button>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-gray-700">Rows per page:</span>
          <select
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="border rounded p-2 bg-white text-gray-700"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default NodesTable;